import getLoginUrl from '../config/getLoginUrl';

export default function navigateToLogin() {

  location.href = getLoginUrl(location.href);
}
